const mediaColors = [
  "#48718c", //
  "#ef5052",
  "#3ba8d7",
  "#eac24a",
  "#c75a28",
  "#ee8329",
  "#b79145",
  "#ce2731",
]

const allColor = "#800fb4"
export const getMediaColorByIndex = (_: string, index: number) =>
  mediaColors[index] || allColor

const mediaColorsByName: Record<string, string> = {
  TV: "#48718c",
  Digital: "#ef5052",
  Print: "#3ba8d7",
  "Out of Home": "#eac24a",
  Event: "#c75a28",
  Radio: "#ee8329",
  Cinema: "#b79145",
  Mobile: "#ce2731",
}

export const getMediaColorByKey = (key: string) =>
  mediaColorsByName[key] || allColor
